import { Image as ImageType } from "shared/types";
import Image from "shared/images";

type ProjectMobileType = {
  mobile: ImageType;
  tablet: ImageType;
};

export const ProjectMobile = (props: ProjectMobileType) => {
  const { mobile, tablet } = props;

  return (
    <div className="project-mobile">
      <div className="content">
        <div className="image">
          <Image name={mobile} title="" />
        </div>
        <div className="image">
          <Image name={tablet} title="" />
        </div>
      </div>
    </div>
  );
};
